import {Service} from './service.model';
import {HolidayEvent} from './schedule/holidayEvent.model';
import {Event} from './event.model';
import {ReservationTypes} from '../enums/reservationTypes.enum';
import {Serializable} from './deserialize.service';
import {tags} from '../constants/customTags.const';
import * as _ from 'lodash';
import * as moment from 'moment';

export class FcEvent implements Serializable<FcEvent> {
    allDay: boolean;
    backgroundColor: string;
    borderColor: string;
    className: string;
    color: any;
    constraint: any;
    data: any;
    durationEditable: boolean;
    editable: boolean;
    end: moment.Moment;
    id: any;
    overlap: boolean;
    rendering: any;
    resourceEditable: boolean;
    resourceId: any;
    resourceIds: any[];
    source: any;
    start: moment.Moment;
    startEditable: boolean;
    textColor: string;
    title: String;
    url: string;
    telemed: boolean;
    display: string;

    deserialize(input: any, subcontractor?: any[], servicesForColor?: Service[]) {
        if (_.isNil(input)) {
            return this;
        }
        // this.data = input.data;
        if (input.data instanceof HolidayEvent) {
            this.data = input.data;
        } else {
            this.data = new Event().deserialize(input.data);
        }
        this.display = input.display;
        this.resourceIds = input.resourceIds;
        this.allDay = input.allDay;
        this.backgroundColor = input.backgroundColor;
        this.borderColor = input.borderColor;
        this.className = input.className;
        this.color = input.color;
        this.constraint = input.constraint;
        if (input.durationEditable) {
            this.durationEditable = input.durationEditable;
        }
        this.editable = input.editable;
        if (input.end instanceof moment) {
            this.end = input.end.toDate();
        } else {
            if (input.end) {
                this.end = moment(input.end);
            } else {
                this.end = moment(_.get(this.data, 'end', undefined));
            }
        }
        this.id = input.id;
        this.overlap = input.overlap;
        this.rendering = input.rendering;
        if (input.resourceEditable) {
            this.resourceEditable = input.resourceEditable;
        }
        this.source = input.source;
        if (input.start instanceof moment) {
            this.start = input.start.toDate();
        } else {
            if (input.start) {
                this.start = moment(input.start);
            } else {
                this.start = moment(_.get(this.data, 'start', undefined));
            }
        }

        if (input.startEditable) {
            this.startEditable = input.startEditable;
        }
        this.textColor = input.textColor;
        this.title = input.title;
        if (input.url) {
            this.url = input.url;
        }

        //set title
        if (this.data.customer) {
            this.title = _.get(this.data, 'customer.name', '') + ' ' + _.get(this.data, 'customer.surname', '');
        } else if (input.title) {
            this.title = input.title;
        } else if (this.data.title) {
            this.title = this.data.title;
        } else {
            this.title = 'BREZ STRANKE';
        }

        if (input.resourceId) {
            this.resourceId = input.resourceId;
        } else {
            this.resourceId = _.get(this.data, 'contractor.subcontractors[0].id', undefined);
        }
        if (servicesForColor) {
            this.getStyle(undefined, servicesForColor);
        } else {
            this.getStyle(subcontractor, undefined);
        }
        // this.editable = input.editable;
        this.telemed = input.telemed;

        return this;
    }

    private getStyle(subcontractor?: any[], services?: Service[]): void {
        // debugger;
        if (services) {
            let foundService = services.find((el) => {
                return el.id === _.get(this.data, 'service.id', -1);
            });

            if (foundService) {
                this.backgroundColor = _.get(foundService, 'color', '');
                // this.textColor = '#000000';
            }
        } else {
            if (subcontractor) {
                let foundSubc = subcontractor.find((el) => {
                    return el.id === this.data.contractor.subcontractors[0].id;
                });
                if (foundSubc) {
                    // debugger;
                    this.backgroundColor = foundSubc.bgColor;
                    this.textColor = foundSubc.fgColor;
                }
            }
        }

        if (this.data.customTagId) {
            // debugger;
            let tag: any = tags.CUSTOM_TERMS_TAGS.find((el) => el.id === this.data.customTagId);
            if (tag) {
                this.className = this.className + ' ' + tag.classColor;
            }
        }

        if (this.data.reservationType === ReservationTypes.DRAFT) {
            this.className = this.className + ' mf-draft-event';
        }
    }
}
